import { Center } from "@mantine/core";
import { useForm } from "@mantine/form";
import { Button, Modal, Text, TextInput } from "components";
import { IRootState } from "config/redux";
import { ServiceConstants } from "constant";
import { TFunction } from "i18next";
import { useCallback, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { CreditService } from "services";
import { CreditRequestAttachmentResponse } from "types";
import { AppUtils } from "utils";

const { REQUEST_CREDIT_ATTACHMENT_UPDATE_ID, REQUEST_PENDING } = ServiceConstants;

interface AttachmentUpdateModalProps {
  item: CreditRequestAttachmentResponse;
  opened: boolean;
  onClose: () => void;
  t: TFunction;
}

const AttachmentUpdateModal = ({ item, opened, onClose, t }: AttachmentUpdateModalProps) => {
  const updateServiceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CREDIT_ATTACHMENT_UPDATE_ID + item.id]);

  useEffect(() => {
    if (!opened) form.setInitialValues({} as CreditRequestAttachmentResponse);
  }, [opened]);

  const updateAttachment = useCallback(() => CreditService.creditAttachmentUpdate(form.getTransformedValues()), []);
  const isLoading = useMemo(() => updateServiceObject && updateServiceObject.status === REQUEST_PENDING, [updateServiceObject]);

  const form = useForm({
    initialValues: { ...item } as CreditRequestAttachmentResponse,
    validate: {
      name: (value: string) => AppUtils.isEmpty(value) ? t('error.required') : null
    }
  })

  return (
    <Modal opened={opened} onClose={onClose} title={t('credit.documentation.delivered.edit.title')}>
      <TextInput
        label={t('credit.documentation.name')}
        key={form.key('name')}
        {...form.getInputProps('name')}
      />
      <Center mt={32}>
        <Button onClick={updateAttachment} disabled={isLoading || !form.isDirty() || !form.isValid()}>
          <Text>{t('action.submit')}</Text>
        </Button>
      </Center>
    </Modal>
  )
}

export default AttachmentUpdateModal;